// src/api/fileService.js
import axios from 'axios';

const API_BASE_URL = `${process.env.REACT_APP_API_BASE_URL}/metadata/translation`;

// Create axios instance with authentication
const api = axios.create({
    baseURL: API_BASE_URL,
    headers: {
        'Content-Type': 'application/json',
    },
});

// Add request interceptor to include auth token
api.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('token'); // Adjust based on your auth implementation
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

// Add response interceptor for error handling
api.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response?.status === 401) {
            // Handle unauthorized access
            localStorage.removeItem('token');
            window.location.href = '/login';
        }
        return Promise.reject(error);
    }
);

export const fetchTranslationInfo = async () => {
  try {
    const response = await api.get(`${API_BASE_URL}/info`);
    return response.data;
  } catch (error) {
    console.error('Error fetching all translation:', error);
    throw error;
  }
};

export const fetchTranslation = async (surahId, translation_id='2') => {
  try {
    const response = await axios.get(`${API_BASE_URL}/${surahId}`, {
      params: {
        translation_id
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching surah:', error);
    throw error;
  }
};

export const verifyTranslation = async (ayahKey, translation_info_id, status, comment, correction) => {
  try {
    await api.post(`${API_BASE_URL}/verification`, {
      ayah_key: ayahKey,
      verification_status: status,
      translation_info_id, 
      comments: comment || '',
      corrections: correction || ''
    });
  } catch (error) {
    console.error('Error deleting verification:', error);
    throw new Error('Failed to delete verification');
  }
}

export const deleteVerification = async (ayah_key, translation_info_id) => {
  try {
    await api.delete(`${API_BASE_URL}/verification`, {
      params:{
        ayah_key,
        translation_info_id
      }
    });
  } catch (error) {
    console.error('Error deleting verification:', error);
    throw new Error('Failed to delete verification');
  }
}

// ========== SUPER_EXPERT ENDPOINTS ==========

export const fetchTranslationForApproval = async (surahId, translation_info_id = '2') => {
  try {
    const response = await api.get(`/super-expert/${surahId}`, {
      params: { translation_info_id }
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching audio for approval:', error);
    throw new Error(error.response?.data?.detail || 'Failed to fetch audio for approval');
  }
};

export const approveTranslation = async (ayahKey, translation_info_id, status, notes) => {
  try {
    const response = await api.post(`/approval`, {
      ayah_key: ayahKey,
      translation_info_id,
      approval_status: status,
      approval_notes: notes || ''
    });
    return response.data;
  } catch (error) {
    console.error('Error approving audio:', error);
    throw new Error(error.response?.data?.detail || 'Failed to approve audio');
  }
};

export const revokeApproval = async (ayah_key, translation_info_id) => {
  try {
    const response = await api.delete(`/approval`, {
      params: { ayah_key, translation_info_id }
    });
    return response.data;
  } catch (error) {
    console.error('Error revoking approval:', error);
    throw new Error(error.response?.data?.detail || 'Failed to revoke approval');
  }
};

export const fetchApprovalStats = async () => {
  try {
    const response = await api.get(`/approval-stats`);
    return response.data;
  } catch (error) {
    console.error('Error fetching approval stats:', error);
    throw error;
  }
};


